module.exports = __webpack_public_path__ + "static/media/mv_bg_sp.743d9c7d.jpg";